export enum SocketTopics {
  APP_MAIN_LISTENER = "APP_MAIN_LISTENER",
  APP_MAIN_EMITTER = "APP_MAIN_EMITTER",
  APP_INSTANCE_LISTENER = "APP_INSTANCE_LISTENER",
  APP_INSTANCE_EMITTER = "APP_INSTANCE_EMITTER",
  PLUGIN_LISTENER = "PLUGIN_LISTENER",
  PLUGIN_EMITTER = "PLUGIN_EMITTER",
}
